'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ChangeEvent } from 'react';
import { type RegisterOptions, useFormContext } from 'react-hook-form';
import { PICTURE_UPLOAD_ERROR_ID } from '@shared/utils/constants/fileUpload';
import { ButtonVariant } from '../button/buttonVariant';
import { ChipTheme } from '../chip/chipTheme';
import styles from './file-input.module.scss';
type FileInputProps = {
  accept: string;
  ariaDescribedBy?: string;
  ariaOwns?: string;
  asChip?: boolean;
  dataTestId?: string;
  hasError: boolean;
  label?: string;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  rules: RegisterOptions;
  theme?: ChipTheme;
  variant?: ButtonVariant;
};
export const FileInput = t0 => {
  const $ = _c(14);
  const {
    accept,
    ariaDescribedBy,
    ariaOwns,
    asChip,
    dataTestId,
    hasError,
    label,
    name,
    onChange,
    rules,
    theme,
    variant
  } = t0;
  const {
    register
  } = useFormContext();
  let t1;
  if ($[0] !== accept || $[1] !== ariaDescribedBy || $[2] !== ariaOwns || $[3] !== asChip || $[4] !== dataTestId || $[5] !== hasError || $[6] !== label || $[7] !== name || $[8] !== onChange || $[9] !== register || $[10] !== rules || $[11] !== theme || $[12] !== variant) {
    t1 = label && <label className={classNames({
      [styles["file-input-label"]]: !asChip,
      [styles["file-input-label--secondary"]]: variant === ButtonVariant.Secondary,
      [styles["file-input-label-chip"]]: asChip,
      [styles["file-input-label-chip--interactive"]]: asChip,
      [styles["file-input-label-chip--theme-light"]]: asChip && theme === ChipTheme.Light
    })} htmlFor={name}><input accept={accept} aria-describedby={hasError ? `${PICTURE_UPLOAD_ERROR_ID} ${ariaDescribedBy}` : ariaDescribedBy} aria-invalid={hasError} aria-owns={ariaOwns} className={styles["file-input"]} data-testid={dataTestId} id={name} type="file" {...register(name, {
        ...rules,
        onChange
      })} />{label}</label>;
    $[0] = accept;
    $[1] = ariaDescribedBy;
    $[2] = ariaOwns;
    $[3] = asChip;
    $[4] = dataTestId;
    $[5] = hasError;
    $[6] = label;
    $[7] = name;
    $[8] = onChange;
    $[9] = register;
    $[10] = rules;
    $[11] = theme;
    $[12] = variant;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
};